import type { CSSProperties, PropsWithChildren } from "react";
import { markdownToHtml } from "../../helpers/markdownToHTML";

const descriptionStyles: CSSProperties = {
  fontSize: "14px",
  lineHeight: "20.8px",
  marginBlockStart: "8px",
};

export function Markdown({ children }: PropsWithChildren) {
  if (!children) {
    return null;
  }
  return <div style={descriptionStyles}>{markdownToHtml(children.toString())}</div>;
}
